<div class="sidenav-drawer" *ngIf="!isMobile"
     [@expandCollapse]="drawerExpanded===true ? 'expanded' : 'collapsed'"
     [class.expanded]="drawerExpanded"
     [@SwipeAnimator]="animationState"
     (@SwipeAnimator.done)="resetAnimationState()"
     (swipeleft)="startAnimation('swipeLeft')"
     (swiperight)="startAnimation('swipeRight')">
  <ng-container *ngFor="let tab of tabs">
    <div *ngIf="tab.visible"
         class="drawer-item"
         routerLinkActive #rla="routerLinkActive"
         [ngClass]="{'active': tab.active || rla.isActive}">
      <a [routerLink]="tab.path">
        <mat-icon>{{tab.icon}}</mat-icon>
        <span *ngIf="drawerExpanded">{{tab.label | translate}}</span>
      </a>
    </div>
  </ng-container>
  <button class="sidenav-toggle-button"
          mat-icon-button
          (click)="toggleDrawer()">
    <img src="assets/images/artoil-mini-logo.png"
         alt="Artoil Portal">
  </button>
</div>

<div class="sidenav-drawer" *ngIf="isMobile"
     [@expandCollapse]="drawerExpanded ? 'expanded' : 'collapsed'"
     [class.expanded]="drawerExpanded"
     [@SwipeAnimator]="animationState"
     (@SwipeAnimator.done)="resetAnimationState()"
     (swipeleft)="startAnimation('swipeLeft')"
     (swiperight)="startAnimation('swipeRight')">
  <div class="circle" *ngIf="hasFab()"></div>
  <div class="left-icons" *ngIf="getLeftIcons().length > 0">
    <div *ngFor="let tab of getLeftIcons()"
         class="icn"
         routerLinkActive #rla="routerLinkActive"
         [ngClass]="{'active': tab?.active || rla.isActive}">
      <a *ngIf="tab?.visible"
         [routerLink]="tab.path">
        <mat-icon *ngIf="tab.svgIcon; else simpleIcon"
                  [svgIcon]="tab.svgIcon">
        </mat-icon>
        <ng-template #simpleIcon>
          <mat-icon>{{tab.icon}}</mat-icon>
        </ng-template>
      </a>
    </div>
  </div>
  <div class="right-icons" *ngIf="getRightIcons().length > 0">
    <div *ngFor="let tab of getRightIcons()"
         class="icn"
         routerLinkActive #rla="routerLinkActive"
         [ngClass]="{'active': tab?.active || rla.isActive}">
      <a *ngIf="tab?.visible"
         [routerLink]="tab.path">
        <mat-icon *ngIf="tab.svgIcon; else simpleIcon"
                  [svgIcon]="tab.svgIcon">
        </mat-icon>
        <ng-template #simpleIcon>
          <mat-icon>{{tab.icon}}</mat-icon>
        </ng-template>
      </a>
    </div>
  </div>
</div>

<div class="sidenav-content" [class.expanded]="drawerExpanded">
  <ng-content></ng-content>
</div>

<app-menu-progress-stepper #stepper *ngIf="isMobileResolution()" [numberOfSteps]="menuSteps" [currentIndex]="menuIndex"
                           [points]="true"></app-menu-progress-stepper>
